import React from 'react'


import gym1 from '../Images/gym1.jpg';
import gym2 from '../Images/gym2.jpg';
import gym5 from '../Images/gym5.jpg';
import gym3 from '../Images/gym3.jpg';
import gym4 from '../Images/gym4.jpg';
import eq1 from '../Images/eq1.jpg';
import Image from 'react-bootstrap/Image'
import Navbar from './Navbar';
import MidPage from '../bootstrap/MidPage';
import CardsPage from '../bootstrap/CardsPage';
import NewData from '../bootstrap/NewData';
import Footer from './Footer';
import Links from '../ExtraPages/Links';



const Home = () => {
  return (
    <>
    <Navbar/>
    <section>
      <img src={gym5} className="main image-fluid"/>
    
    </section>
    <section>
      <MidPage/>
    </section>
    <section>
      <CardsPage/>
    </section>
    <section>
      <Footer/>
    </section>
   
  
    
    </>
  )
}

export default Home